/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnswerDTO
 */
export interface AnswerDTO {
    /**
     * 
     * @type {number}
     * @memberof AnswerDTO
     */
    questionId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AnswerDTO
     */
    choiceIndices?: Array<number> | null;
}

/**
 * Check if a given object implements the AnswerDTO interface.
 */
export function instanceOfAnswerDTO(value: object): value is AnswerDTO {
    return true;
}

export function AnswerDTOFromJSON(json: any): AnswerDTO {
    return AnswerDTOFromJSONTyped(json, false);
}

export function AnswerDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnswerDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'questionId': json['questionId'] == null ? undefined : json['questionId'],
        'choiceIndices': json['choiceIndices'] == null ? undefined : json['choiceIndices'],
    };
}

export function AnswerDTOToJSON(json: any): AnswerDTO {
    return AnswerDTOToJSONTyped(json, false);
}

export function AnswerDTOToJSONTyped(value?: AnswerDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questionId': value['questionId'],
        'choiceIndices': value['choiceIndices'],
    };
}

